import { Box } from "@mui/material";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  modifyRestaurant,
  getRestaurantsError,
  getRestaurantsLoading,
  getRestaurantsStatus,
  getRestaurantsSuccess,
  updateStatus,
} from "../../features/restaurantsSlice";
import { useLocation, useNavigate } from "react-router-dom";
import RestaurantAppBar from "../../components/restaurantTopBar";
import RestaurantForm from "./restaurantForm";
import { appendImageFormFields } from "../../global/functions/imageHelper";
import BackButton from "../../components/backButton";
import { useTranslation } from "react-i18next";

const ModifyRestaurant = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state.restaurant;
  const [previewImage, setPreviewImage] = useState(null);
  const status = useSelector(getRestaurantsStatus);
  const error = useSelector(getRestaurantsError);
  const loading = useSelector(getRestaurantsLoading);
  const success = useSelector(getRestaurantsSuccess);

  const initialValues = {
    name: data.name,
    address: data.address,
    active: data.active,
    description: data.description,
  };

  const handleFormSubmit = (values) => {
    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("address", values.address);
    formData.append("active", values.active);
    formData.append("description", values.description);

    if (previewImage) {
      appendImageFormFields(formData, previewImage, "logo");
    }

    dispatch(
      modifyRestaurant({
        body: formData,
        restaurantId: data._id,
      })
    );
  };

  useEffect(() => {
    if (status === "modifySuccess") {
      toast.success(success);
      dispatch(updateStatus());
      navigate("/restaurants");
    } else if (status === "modifyError") {
      toast.error(error);
    }
  }, [status, error, dispatch, navigate, success]);

  return (
    <div className="main-application">
      <RestaurantAppBar />
      <Box m="20px" className="main-application">
        <BackButton/>
        <Header title={t("headers.editRestaurant")} subtitle={t("headers.editRestaurantSub")} />
        <main>
          <RestaurantForm
            buttonText={t("common.edit")}
            handleFormSubmit={handleFormSubmit}
            initialValues={initialValues}
            previewImage={previewImage}
            setPreviewImage={setPreviewImage}
            image={data.logo}
            imageId={data.logoId}
            restaurantId={data._id}
            loading={loading}
          />
        </main>
      </Box>
    </div>
  );
};

export default ModifyRestaurant;
